import React, { useContext } from 'react'
import { Styled } from './NavItemsBlack.styled'
import { ArrowLeftMenu, Doubt } from 'components/Icons/Icons'
import arrowMobile from 'assets/images/ico/ico-arrow-left-white2.png'
import pushDataLayerGTM from 'util/pushDataLayerGTM'

import { TabContext } from 'components/Tab/Tab'
import { useCount } from 'util/context/Count'

const NavItemsBlack = (props) => {
  const { handleChangeTab, myFunc } = useContext(TabContext)
  const { count } = useCount()

  const [state, setState] = React.useState({
    isLoggedIn: JSON.parse(localStorage.getItem('auth-token')),
    infoUsuario: [],
    isVisibleParaMim: false,
    isVisibleMeusPontos: false,
    msg: '',
    msgType: '',
    linkVitrine: '',
    loadInfo: false,
  })

  const clickLinkMenu = (valueEvent) => {
    setState({
      ...state,
      isVisibleParaMim: false,
      isVisibleMeusPontos: false,
    })
    if (window.innerWidth < 1024) {
      props.CloseMenu()
    }

    let category = 'geral'
    let action = 'clique:footer'
    let label = valueEvent
    const additionalData = { position: 'footer' }
    pushDataLayerGTM(category, action, label, additionalData)
  }
  return (
    <Styled.Wrap>
      <Styled.primeiroNivel>
        <Styled.itemPrimeiroNivel className="itemPrimeiroNivel">
          <Styled.linkMenu
            to={'/sobre-o-portoplus'}
            onClick={() => clickLinkMenu('Sobre o PortoPlus')}
          >
            <span>Sobre o PortoPlus</span>
          </Styled.linkMenu>
        </Styled.itemPrimeiroNivel>

        <Styled.itemPrimeiroNivel className="itemPrimeiroNivel">
          <Styled.linkMenu
            ativo={state.isVisibleParaMim}
            onClick={() => {
              setState({ ...state, isVisibleParaMim: !state.isVisibleParaMim })
            }}
          >
            <span>FAQ</span>
            <Styled.iconeSeta
              className="iconeSeta"
              ativo={state.isVisibleParaMim}
            >
              <ArrowLeftMenu />
              <img src={arrowMobile} alt="" />
            </Styled.iconeSeta>
          </Styled.linkMenu>
          <Styled.Submenu className="submenu" ativo={state.isVisibleParaMim}>
            <ul>
              {state.isLoggedIn?.typePerson === 'Physics' && (
                <Styled.itemSegundoNivel className="itemSegundoNivel">
                  <Styled.linkMenu
                    to={'/faq/cartao'}
                    onClick={() => clickLinkMenu('faq-cartao')}
                  >
                    <Styled.iconeMenu>
                      <Doubt />
                    </Styled.iconeMenu>
                    <span>FAQ Cartão</span>
                  </Styled.linkMenu>
                </Styled.itemSegundoNivel>
              )}

              {state.isLoggedIn?.typePerson === 'Legal' && (
                <Styled.itemSegundoNivel className="itemSegundoNivel">
                  <Styled.linkMenu
                    to={'/faq/corretor'}
                    onClick={() => clickLinkMenu('faq-corretor')}
                  >
                    <Styled.iconeMenu>
                      <Doubt />
                    </Styled.iconeMenu>
                    <span>FAQ Corretor</span>
                  </Styled.linkMenu>
                </Styled.itemSegundoNivel>
              )}

              <Styled.itemSegundoNivel className="itemSegundoNivel">
                <Styled.linkMenu
                  to={'/faq/descontos'}
                  onClick={() => clickLinkMenu('faq-descontos')}
                >
                  <Styled.iconeMenu>
                    <Doubt />
                  </Styled.iconeMenu>
                  <span>FAQ Compras Com Desconto</span>
                </Styled.linkMenu>
              </Styled.itemSegundoNivel>
            </ul>
          </Styled.Submenu>
        </Styled.itemPrimeiroNivel>
        <Styled.itemPrimeiroNivel className="itemSegundoNivel mb-2">
          <Styled.linkMenu
            to="//cliente.portoseguro.com.br/portaldecliente/?utm_source=Portoplus&utm_medium=Site&utm_campaign=Rodape"
            rel="noopener noreferrer"
            target="_blank"
          >
            <p>Área do Cliente</p>
          </Styled.linkMenu>
        </Styled.itemPrimeiroNivel>
        <Styled.itemPrimeiroNivel className="itemSegundoNivel mb-2">
          <Styled.linkMenu
            className="teste"
            to="//corretor.portoseguro.com.br/corretoronline/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <p>Corretor Online</p>
          </Styled.linkMenu>
        </Styled.itemPrimeiroNivel>
      </Styled.primeiroNivel>
    </Styled.Wrap>
  )
}

export default NavItemsBlack
